import React from 'react';

const CompareOptions = ({ data }) => {
  if (!data) return null;

  return (
    <section className="bg-white py-sp-100 sm:sp-big">
      <div className="container px-3">
        <div className="text-center mb-6 sm:mb-8">
          {data.heading && (
            <h2 className="text-[#2C2C2C] text-xxxl sm:text-lg font-medium mx-auto mb-3">
              {data.heading}{' '}
              {data.boldHeading && (
                <strong className="font-bold text-[#072F5F]">{data.boldHeading}</strong>
              )}
            </h2>
          )}
          {data.description && (
            <p className="text-[#6F6F6F] text-base2 sm:text-sm mx-auto">
              {data.description}
            </p>
          )}
        </div>

        <div className="mx-auto overflow-x-auto shadow-sm">
          <div className="min-w-[650px] rounded-2xl overflow-hidden border border-[#E2E8F0] shadow-sm flex flex-col">
            <div className="flex w-full">
              <div className="w-[35%] bg-[#022B5C] text-white p-3 sm:p-3 text-sm sm:text-xs font-medium flex items-center">
                {data.headers?.col1}
              </div>
              <div className="w-[35%] bg-[#022B5C] text-white p-3 sm:p-3 text-sm sm:text-xs font-medium flex items-center">
                {data.headers?.col2}
              </div>
              <div className="w-[30%] bg-gradient-to-r from-[#022B5C] to-[#0052CC] transition-all duration-300 transform text-white p-3 sm:p-3 text-sm sm:text-xs font-medium flex items-center">
                {data.headers?.col3}
              </div>
            </div>

            <div className="flex flex-col">
              {data.rows?.map((row, index) => (
                <div
                  key={row.id}
                  className={`flex w-full border-t border-[#E2E8F0] ${index % 2 === 0 ? 'bg-white' : ''
                    }`}
                >
                  <div className="w-[35%] p-3 sm:p-3 text-[#2C2C2C] font-medium text-sm sm:text-xs flex items-center">
                    {row.component}
                  </div>
                  <div className="w-[35%] p-3 sm:p-3 text-[#6F6F6F] text-sm sm:text-xs flex items-center border-l border-[#F1F5F9]">
                    {row.existingRoute}
                  </div>
                  <div className="w-[30%] p-3 sm:p-3 text-[#059A6D] font-medium text-sm sm:text-xs bg-[#E2E9FF59] flex items-center gap-2">
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="shrink-0"
                    >
                      <circle cx="10" cy="10" r="10" fill="#059A6D" />
                      <path
                        d="M6 10L9 13L14 7"
                        stroke="#FFFFFF"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <span>{row.inrExpress}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {data.footnote && (
          <p className="text-center text-[#9CA3AF] text-xs px-5 mt-2 mb-8">
            {data.footnote}
          </p>
        )}
      </div>
    </section>
  );
};

export default CompareOptions;
